<template>
  <div class="main-container">
    <div class="bread">
      <router-link :to="{name:'ExamIndex'}">在线测评</router-link>
      <span class="slash">/</span>
      <router-link :to="{name:'ExamPackage'}">套卷练习</router-link>
      <span class="slash">/</span>
      <span class="current">{{detail.name}}</span>
    </div>
    <div class="main-content">
      <div class="detail-wrap">
        <img class="img" src="@/assets/images/exam/package@2x.png" />
        <div class="name-wrap">
          <div class="name">{{detail.name}}</div>
          <div class="description">{{detail.description}}</div>
        </div>
      </div>
      <div class="papers">
        <div class="paper" v-for="paper in detail.exam" :key="paper.id">
          <div>
            <div class="name">{{paper.name}}</div>
            <div class="num">{{paper.practiceNum}}人已练过</div>
          </div>
          <a class="btn" @click="onDo(paper)">套卷练习</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ExamPackagePaper",
  data() {
    return {
      id: this.$route.query.id,
      detail: {}
    };
  },
  async created() {
    this.detail = await this.$http.get("/api/app/practice/package/" + this.id);
  },
  methods: {
    async onDo(paper) {
      let data = await this.$http.post("/api/app/practice/report", {
        type: 2,
        package_id: this.id,
        exam_id: paper.id
      });
      if (data.length === 0) {
        this.$info("当前没有题目可以练习");
        return;
      }
      this.$router.push({
        name: "ExamPackagePaperDetail",
        query: {
          package_id: this.id,
          package_name: this.detail.name,
          id: paper.id,
          report_id: data
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.main-content {
  background: rgba(255, 255, 255, 1);
  border-radius: 5px;
  padding: 21px 30px 34px 30px;
  margin-bottom: 30px;
}
.detail-wrap {
  display: flex;
  background-color: #f7f7f7;
  padding: 20px 30px 20px 20px;
  margin-bottom: 39px;

  .img {
    width: 70px;
    height: 92px;
    margin-right: 21px;
  }

  .name {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 1;
    margin-bottom: 22px;
  }

  .description {
    font-size: 14px;
    color: #808080;
    line-height: 24px;
  }
}
.paper {
  font-size: 14px;
  line-height: 1;
  border-bottom: 1px solid #ededed;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;

  .name {
    color: black;
    margin-bottom: 16px;
  }

  .num {
    color: #999999;
    margin-bottom: 20px;
  }

  .btn {
    width: 86px;
    height: 32px;
    background: $primary-color;
    border-radius: 3px;
    line-height: 32px;
    text-align: center;
    color: white;
    font-size: 14px;
    cursor: pointer;
    margin-top: 4px;
  }
}
</style>